export const DATADOG_ID = "DATADOG_SYNTHETICS_BROWSER";
